module.exports = __webpack_public_path__ + "img/empty-rewards.e515031f.jpg";